<mat-toolbar color="primary" class="toolbar--container mat-elevation-z6">
  <div class="flex-spacer"></div>
  <span class="app-title">
    <img src="/images/core/orion-logo.svg" class="brand" alt="Orion Logo" />
  </span>

  <div class="flex-spacer"></div>

  <nav class="toolbar-action--container d-flex align-items-center" mat-tab-nav-bar>
    <orion-platform-context-menu
      #plantCtxMenu
      [hideTrigger]="true"
      selectionMode="radio"
      xPosition="before"
      [testId]="testIds.plantMenu"
      [items]="plantMenuItems()"
      (actionSelected)="onPlantMenuAction($event)" />

    @if (activePlant()?.Code) {
      <button
        mat-button
        [matMenuTriggerFor]="plantCtxMenu.menu()"
        [attr.data-testid]="testIds.plantButton"
        class="toolbar-action-item gap-2">
        <mat-icon class="iconLogin">business</mat-icon>
        {{ activePlant()!.Code + ' | ' + activePlant()!.Name }}
      </button>
    }

    <orion-platform-context-menu
      #languageCtxMenu
      [hideTrigger]="true"
      selectionMode="radio"
      xPosition="before"
      [items]="languageMenuItems()"
      [testId]="testIds.languageMenu"
      (actionSelected)="onLanguageMenuAction($event)" />

    <button
      mat-button
      [matMenuTriggerFor]="languageCtxMenu.menu()"
      [attr.data-testid]="testIds.languageButton"
      class="toolbar-action-item gap-2">
      <mat-icon>language</mat-icon>
      {{ currentLang()?.description }}
    </button>

    @if (userName()) {
      <button
        mat-button
        [matMenuTriggerFor]="notificationsMenu"
        [attr.data-testid]="testIds.notificationsButton"
        class="toolbar-action-item">
        @if (notificationsUnreadCount() > 0) {
          <mat-icon [matBadge]="notificationsUnreadCount()" matBadgeColor="warn">
            notifications
          </mat-icon>
        } @else {
          <mat-icon>notifications</mat-icon>
        }
      </button>

      <mat-menu #notificationsMenu="matMenu" class="custom">
        <div [attr.data-testid]="testIds.notificationsMenu">
          @switch (notificationsStatus()) {
            @case (0) {
              <button mat-menu-item [attr.data-testid]="testIds.notificationEmpty">
                <span class="notification read">
                  <span class="title">{{ 'toolbar.emptyNotifications' | translate }}</span>
                </span>
              </button>
            }
            @case (1) {
              @for (notification of notifications().slice(0, 5); track notification.id) {
                <button
                  mat-menu-item
                  [attr.data-testid]="testIds.notificationItem + '-' + notification.id"
                  (click)="goToNotifications(notification.id)">
                  <span class="notification" [class.read]="notification.isRead">
                    <span class="title">{{ notification.title }}</span>
                  </span>
                </button>
              }
            }
            @case (2) {
              <div class="spinner-center" [attr.data-testid]="testIds.notificationLoading">
                <mat-progress-spinner
                  [color]="color()"
                  [mode]="mode()"
                  [diameter]="diameter() || 25"
                  [value]="value()"></mat-progress-spinner>
              </div>
            }
            @case (3) {
              <button mat-menu-item [attr.data-testid]="testIds.notificationError">
                <span class="notification read">
                  <span class="title">{{ 'toolbar.notificationsError' | translate }}</span>
                </span>
              </button>
            }
          }
        </div>
      </mat-menu>
    }

    @if (documentationLink()) {
      <a
        class="menu-item d-flex align-items-center"
        [href]="documentationLink()"
        target="_blank"
        [attr.data-testid]="testIds.helpLink"
        [title]="'toolbar.help' | translate">
        <mat-icon>help</mat-icon>
      </a>
    }

    <orion-platform-context-menu
      #userCtxMenu
      [hideTrigger]="true"
      xPosition="before"
      [items]="userMenuItems"
      [testId]="testIds.userMenu"
      (actionSelected)="onUserMenuAction($event)" />

    <button
      mat-button
      [matMenuTriggerFor]="userCtxMenu.menu()"
      [attr.data-testid]="testIds.userButton"
      class="toolbar-action-item">
      <mat-icon>person</mat-icon>
      {{ userName() }}
    </button>
  </nav>
</mat-toolbar>
